/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Group = {
    properties: {
        id: {
            type: 'number',
        },
        name: {
            type: 'Translation',
        },
        team: {
            type: 'TeamListMinimum',
            isRequired: true,
        },
        message: {
            type: 'string',
        },
        key: {
            type: 'string',
        },
        blocked: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
